var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBylawModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_2755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3439 0.705078C11.8759 0.257487 11.116 0.257487 10.6481 0.705078L6.15588 5.00195C5.68795 5.44954 5.68795 6.17643 6.15588 6.62402L6.75484 7.19694C7.22278 7.64453 7.98271 7.64453 8.45064 7.19694L8.60038 7.05371L12.5984 10.8743L12.4487 11.0176C11.9808 11.4652 11.9808 12.1921 12.4487 12.6396L13.0477 13.2126C13.5156 13.6602 14.2755 13.6602 14.7435 13.2126L19.2356 8.91569C19.7036 8.4681 19.7036 7.74121 19.2356 7.29362L18.6367 6.7207C18.1687 6.27311 17.4088 6.27311 16.9409 6.7207L16.7911 6.86393L12.7931 3.03971L12.9428 2.89648C13.4108 2.44889 13.4108 1.72201 12.9428 1.27441L12.3439 0.701497V0.705078ZM6.65377 11.0176C6.18583 10.57 5.4259 10.57 4.95797 11.0176L0.765259 15.028C0.297323 15.4756 0.297323 16.2025 0.765259 16.6501L2.56213 18.3688C3.03007 18.8164 3.79 18.8164 4.25794 18.3688L8.45064 14.3584C8.91858 13.9108 8.91858 13.1839 8.45064 12.7363L8.39824 12.6862L10.5994 10.5843L8.90361 8.96224L6.70618 11.0641L6.65377 11.014V11.0176Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_2755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1667,
    height: 18.3333,
    fill: "white",
    transform: "translate(0.416992 0.3685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBylawModel);
export default __webpack_public_path__ + "static/media/bylaw-model.823ca3ab3accbc6a17c57e3ed3aa8a05.svg";
export { ForwardRef as ReactComponent };